var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manager-role-assignment pa-4 bg-grey-lighten-4",staticStyle:{"min-height":"100vh"}},[_c('OfficeRoleCard',{staticClass:"mb-8"}),_c('SalesRoleCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }